import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface CustomObject {
    [key: string]: any;
}
interface FiltersButtonProps {
    filter: CustomObject;
    showFilters: boolean;
    onClick: () => void;
    classes?: string;
    classesText?: string;
    minWidth?: boolean;
}

const FiltersButton: React.FC<FiltersButtonProps> = ({
    filter,
    showFilters,
    onClick,
    classes,
    classesText,
    minWidth,
}) => {
    const { t } = useTranslation();
    const isValueActive = (value: unknown): boolean => {
        if (value === null || value === "" || value === undefined) {
            return false;
        }
        if (Array.isArray(value)) {
            return value.some(isValueActive);
        }
        if (typeof value === "object") {
            return Object.values(value as Record<string, unknown>).some(isValueActive);
        }
        return true;
    };
    const hasActiveFilters = Object.values(filter).some(isValueActive);
    return (
        <Button
            variant="outline-primary"
            className={`fw-normal rounded-1 px-1 ${showFilters ? "bg-additional-violet" : ""} ${classes} ${minWidth ? "filters-btn-width" : "w-100"}`}
            onClick={onClick}
        >
            <i className="bi bi-funnel position-relative">
                {hasActiveFilters ? (
                    <span
                        className="d-block bg-orange position-absolute end-0 top-0 rounded-circle"
                        style={{ width: "5px", height: "5px" }}
                    ></span>
                ) : null}
            </i>
            <span className={`${classesText} ms-2`}>{t("filters")}</span>
        </Button>
    );
};

export default FiltersButton;
